import s from "./Kbd.module.css";

const IS_MAC = typeof navigator !== "undefined" && /Mac|iP(hone|ad|od)/.test(navigator.platform);

/** Renders "Mod+P" as ⌘P on mac / Ctrl P elsewhere. */
export function Kbd({ combo }: { combo: string }) {
  const keys = combo.split("+").map((k) => {
    const key = k.trim();
    if (key === "Mod") return IS_MAC ? "⌘" : "Ctrl";
    if (key === "Shift") return IS_MAC ? "⇧" : "Shift";
    if (key === "Alt") return IS_MAC ? "⌥" : "Alt";
    if (key === "Enter") return "↵";
    return key;
  });
  return (
    <span className={s.kbd}>
      {keys.map((k, i) => (
        <span key={i} className={s.key}>
          {k}
        </span>
      ))}
    </span>
  );
}
